<div *ngIf="!disabled">
  <bdg-label class="col-12 row mt-n2" type="body-1">
    Clique no botão abaixo para replicar os valores de bolsas solicitadas na coluna de bolsas aprovadas.
  </bdg-label>
  <div class="mt-3 mb-3">
    <bdg-button (click)="onReplicarValores()" label="REPLICAR VALORES"></bdg-button>
  </div>
</div>
<bdg-form [formGroup]="form" [formValidator]="validator">
  <table
    [formGroup]="form"
    mat-table
    [dataSource]="value"
    class="w-100 border"
    aria-label="Distribuição de bolsas aprovadas"
  >
    <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
      <th mat-header-cell class="mat-cell" *matHeaderCellDef scope="col">
        {{ column.header }}
      </th>

      <ng-container *ngIf="!isEditableCell(column)">
        <td mat-cell *matCellDef="let row; let i = index">
          {{ column.cell(row) }}
        </td>
      </ng-container>

      <ng-container *ngIf="isEditableCell(column)">
        <td mat-cell *matCellDef="let row; let i = index" formArrayName="distribuicoes">
          <div class="d-flex justify-content-end" [formGroupName]="i">
            <mat-icon *ngIf="canShowError(i)" class="mat-error align-self-center mr-2">error</mat-icon>
            <mat-form-field appearance="outline" class="text-input">
              <input
                type="number"
                class="text-center"
                matInput
                formControlName="numeroBolsasAprovadas"
                min="0"
                autocomplete="off"
                (blur)="onTouched()"
              />
            </mat-form-field>
          </div>
        </td>
      </ng-container>

      <td mat-footer-cell *matFooterCellDef>{{ getFootCellValue(column) }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
  </table>
  <div class="ml-2 mt-2">
    <bdg-error-field [control]="control"></bdg-error-field>
  </div>
</bdg-form>
